import React from "react";
import { motion } from "framer-motion";

const servicesData = [
  { title: "Custom Software", description: "Tailor-made software solutions, integrating AI and machine learning to optimise business processes and drive innovation." },
  { title: "Web Development", description: "Responsive, high-performance websites crafted for seamless user experiences, optimised for speed and mobile-first design." },
  { title: "Mobile App Development", description: "End-to-end mobile app solutions, focusing on user-centric design, speed and scalability for iOS and Android platforms." },
  { title: "Cloud Solutions", description: "Scalable, secure and cost-effective cloud computing services, enabling businesses to streamline operations and ensure high availability." }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

const Services = () => {
  return (
    <section
      id="services"
      className="relative py-20 bg-gradient-to-br from-gray-900 to-black text-white overflow-hidden pt-32"
    >
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="absolute bg-blue-400 rounded-full blur-3xl opacity-10 w-64 h-64 top-16 left-6 animate-pulse-slow"></div>
        <div className="absolute bg-purple-500 rounded-full blur-3xl opacity-10 w-72 h-72 bottom-10 right-6 animate-pulse-slow"></div>
      </div>

      <div className="container mx-auto text-center px-6 z-10 relative">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-extrabold mb-12 drop-shadow-glow"
        >
          Our Expertise
        </motion.h2>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          {servicesData.map((service, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              className="bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all border border-gray-700 hover:border-blue-500"
            >
              <h3 className="text-2xl font-semibold text-cyan-400">{service.title}</h3>
              <p className="mt-4 text-gray-300">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;